// extracted by mini-css-extract-plugin
export default {"printPage":"Content_printPage__mYyL1","printBackgroundImage":"Content_printBackgroundImage__NypTv","printContent":"Content_printContent__bF+S+","tight":"Content_tight__vRJtP"};